import React from "react";
import { ChevronDown, ChevronUp } from "@bedrock/icons-react";
import { Button, Space } from "@bedrock/components";
import styles from './index.less';
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

interface Props {
  defaultExpanded?: boolean;
  icon?: React.ReactNode;
  title?: React.ReactNode;
  extra?: React.ReactNode;
  content?: React.ReactNode;
  showExpand?: boolean;
  style?: React.CSSProperties;
  titleStyle?: React.CSSProperties;
}

const ExpandCard: React.FC<Props> = ({
  defaultExpanded = false,
  showExpand = true,
  icon,
  title,
  extra,
  content,
  style,
  titleStyle,
}) => {
  const [expanded, setExpanded] = React.useState(defaultExpanded);

  return (
    <div className={cx('expand-card__container')} style={style}>
      <div className={cx('expand-card__header')}>
        <div className={cx('expand-card__header-left')}>
          <Space size='xs' align='baseline'>
            {icon}
            {title && <span className={cx('expand-card__title')} style={titleStyle}>{title}</span>}
            {showExpand && <Button
              type='link'
              onClick={() => setExpanded(!expanded)}
              suffixIcon={expanded ? <ChevronUp /> : <ChevronDown />}
            >
              详情
            </Button>}
          </Space>
        </div>
        <div className={cx('expand-card__header-right')}>
          {extra}
        </div>
      </div>
      {expanded && <div className={cx('expand-card__content')}>
        {content}
      </div>}
    </div>
  )
}

export default ExpandCard